/**
 * The identifier for the data store.
 *
 * @type {string}
 */
export const STORE_KEY = 'core/edit-post';

/**
 * CSS selector string for the admin bar view post link anchor tag.
 *
 * @type {string}
 */
export const VIEW_AS_LINK_SELECTOR = '#wp-admin-bar-view a';

/**
 * CSS selector string for the admin bar preview post link anchor tag.
 *
 * @type {string}
 */
export const VIEW_AS_PREVIEW_LINK_SELECTOR = '#wp-admin-bar-preview a';
